
import React, { Fragment, useEffect, useRef } from "react"
import InvoiceCycleGrid from '../../jsons/invoicecycles/invoicecyclesGrid';
import Container from '../../../core/controls/components/container'
//const Admin = 'http://development.delasoft.com:8443/AMES-admin'

//xttype
const InvoiceCycGridScreen = (props) => {

    return (
        <Fragment>
            <Container {...InvoiceCycleGrid} {...props} />

        </Fragment>
    )
}

export default InvoiceCycGridScreen



